import React from 'react';
import { Grid } from '@material-ui/core';

import { FormTextField, FormSelect } from '../../../../components';
import { KEY_STORE_DEPLOYMENT_FILTER_TYPE } from '../../../../constants';

export const FilterByName = (props) => (
  <Grid item md={3} sm={4} xs={12}>
    <FormTextField
      {...props}
      id="key-store-proxy-filter-by-name"
      data-apim-test="key-store-proxy-filter-by-name"
    />
  </Grid>
);

export const FilterByKeyStoreName = (props) => (
  <Grid item md={3} sm={4} xs={12}>
    <FormTextField
      {...props}
      id="key-store-proxy-filter-by-key-store-name"
      data-apim-test="key-store-proxy-filter-by-key-store-name"
    />
  </Grid>
);

export const FilterByDeploymentType = (props) => (
  <Grid item md={3} sm={4} xs={12}>
    <FormSelect
      {...props}
      id="key-store-proxy-filter-by-deployment-type"
      data-apim-test="key-store-proxy-filter-by-deployment-type"
      data={KEY_STORE_DEPLOYMENT_FILTER_TYPE}
      noNoneOption
      noNativeSelect
    />
  </Grid>
);

export const FilterAndSortSeparator = () => (
  <Grid item md={3} />
);
